// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-FTq","input":"styles_input__Q_Vkl"};